import {Directive, HostListener} from '@angular/core';
import {NgControl} from '@angular/forms';

@Directive({
  selector: '[contaBancariaMask]'
})
export class ContaBancariaMaskDirective {

  constructor(private ngControl: NgControl) {}

  @HostListener('input', ['$event'])
  onInput(event: any) {
    let value = event.target.value || '';

    value = value.replace(/\D/g, '');
    if (value.length > 10) {
      value = value.substring(0, 10);
    }

    // Aplica máscara: 0000000000
    value = value.replace(/\D/g, '').slice(0, 10);

    this.ngControl.control.setValue(value, { emitEvent: false });
  }
}
